import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { clearCompaniesFilter, setCompaniesFilter } from '../actions/ui.actions';
import { CompaniesFilter } from '../interfaces/companies-filter.interface';

export const COMPANIES_UI_FEATURE = 'companies_ui';

export interface CompaniesUiState {
    companiesFilter?: CompaniesFilter;
}

export const initialUiState: CompaniesUiState = {
    companiesFilter: {}, // Initialize companiesFilter as an empty object
};

const _uiReducer = createReducer(
    initialUiState,

    on(setCompaniesFilter, (state, { filter }) => ({
        ...state,
        companiesFilter: {
            ...state.companiesFilter,
            ...filter,
        },
    })),
    on(clearCompaniesFilter, (state) => ({
        ...state,
        companiesFilter: {}, // Reset companiesFilter to an empty object
    })),
);

export function uiReducer(state: CompaniesUiState | undefined, action: Action) {
    return _uiReducer(state, action);
}

export const selectUiState = createFeatureSelector<CompaniesUiState>(COMPANIES_UI_FEATURE);

export const selectCompaniesFilter = () =>
    createSelector(selectUiState, (state): CompaniesFilter => state.companiesFilter || {});